import type { ReactNode } from "react";

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
}

export function SectionHeader({ icon, title }: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-1 mb-5">
      {icon}
      <h2 className="text-lg font-semibold text-text-primary">{title}</h2>
    </div>
  );
}
